export default __webpack_public_path__ + "./fonts/invertir.36eabc92.svg";